import styled from 'styled-components';

export const OnboardingStyled = styled.div`
  .page-content {
    margin-bottom: 20px;
    .Polaris-Page__Content {
      padding: 0;
    }
    .block-header {
      padding: 0.5rem 3rem;
      position: sticky;
      top: 0;
      z-index: 2;
      background-color: white;
    }
  }

  .step-title-container {
    display: flex;
    justify-content: space-between;
    margin-top: 0.5rem;
  }

  .step-title {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.3);
    text-align: center;
  }
  .step-title.active {
    color: rgba(0, 0, 0, 1);
  }

  .est-welcome-description {
    @media screen and (min-width: 768px) {
      padding: 0 96px;
    }
  }

  @media (max-width: 600px) {
    .Polaris-Layout {
      margin-bottom: 6rem;
    }
  }

  .gif-image {
    /* height: 100%; */
    max-width: 100%;
    max-height: 60vh;
    border-radius: 0.75rem;
  }

  .step-content {
    min-height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .footer-buttons {
      display: flex;
      flex-direction: column;
      align-items: center;
      * {
        width: fit-content;
      }
    }
  }

  .step-1 {
    .welcome-img {
      max-width: 785px;
      width: 70%;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
  }

  .step-2 {
    padding: 0.5rem 3rem 3.5rem;
    .button-select-type {
      border-radius: 12px;
      border: 1px solid rgba(0, 0, 0, 0.13);
      overflow: hidden;
      &.selected {
        border-color: #b7d6ff;
        border-width: 2px;
      }
      .button-title {
        font-weight: 600;
        font-size: 15px;
        text-align: center;
      }
    }
  }

  .step-3 {
    min-height: 80vh;
    .quick-template-img {
      width: 100%;
    }
    .quick-template {
      cursor: pointer;
      &.active {
        .Polaris-ShadowBevel {
          border: 1px solid rgba(0, 0, 0, 0.5);
          box-shadow: 0px 4px 6px -2px rgba(26, 26, 26, 0.2);
        }
      }
    }
    .quick-template-img.border-bottom {
      border-bottom: 1px solid rgba(0, 0, 0, 0.5);
    }
    .quick-template-description {
      padding: 0.25rem 0 0.5rem 1rem;
      display: flex;
      flex-direction: column;
    }
    .title {
      display: flex;
      justify-content: center;
      position: relative;
    }
    .button-group {
      margin-bottom: 2rem;
      margin-top: 0.5rem;
      display: flex;
      justify-content: center;
      background-color: white;
    }
  }
  .step-4 {
    min-height: 70vh;
    display: flex;
    flex-direction: column;
    gap: 48px;
    .add-checkout-block-container {
      width: 600px;
      background-color: #ebf7ff;
      padding: 32px;
      border-radius: 16px;
      .list-step {
        margin-top: 0;
        margin-bottom: 16px;
      }
      .add-block-checkout-image {
        width: 100%;
        object-fit: cover;
      }
    }
  }
`;
